import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AddGivingComponent } from '../../giving/add-giving/add-giving.component';
import { AccountService } from '../../users/data/services/account.service';


@Component({
  selector: 'app-group-check',
  templateUrl: './group-check.component.html',
  styleUrls: ['./group-check.component.sass']
})
export class GroupCheckComponent implements OnInit {


  displayedColumns: string[] = [
    "select",
    "id",
    "groups",
    "church",
   
     "members",

   
  ];

  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  contextMenu: MatMenuTrigger;
  subscription!: Subscription;
  selection = new SelectionModel<any>(true, []);
  data: any;
  error: any;

  formData: any;

  isLoading = true;

  

  groupsDetails: any;
  selectedRows: any[] = [];
  atleastOneSelected: boolean = false;

  dataSourceFilteredList: any[] = [];
  groupsArray: any[] = [];

  destroy$: Subject<boolean> = new Subject<boolean>();



  constructor(
    public dialogRef: MatDialogRef<AddGivingComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
   
    private accountService: AccountService,
  ) { }

  ngOnInit(): void {
  
    this.getData();

   

  }
  ngAfterViewInit() {

    console.log("Finally: ", this.dataSourceFilteredList);

   
  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  filter() {
    //let storeId = [1, 2, 3];
    this.dataSource.data.forEach((element) => {
      this.groupsArray.forEach((item) => {
        if (item === element.id) {
          // this.dataSourceFilteredList.push(this.dataSource.data.indexOf(element));
          this.selection.select(element);
        }
      });
    });

    console.log("dataSourceFilteredList ", this.dataSourceFilteredList);
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  //******************************************************************************************************
  //Select expense

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  expSelected() {
    this.atleastOneSelected = true;
    this.selectedRows = this.selection.selected;

    console.log("this.selectedRows: ", this.selectedRows);
  }
  proceed() {
    this.dialogRef.close({ event: "close", data: this.selectedRows });

    //   console.log(data);
  }

  onNoClick(): void {
    this.dialogRef.close({ event: "close", data: this.selectedRows });
  }
  public confirmAdd(): void { }

  getData() {
    this.subscription = this.accountService.getAllGroups().subscribe(res => {
      this.data = res;
      console.log("groups is  there=", res);

      if (this.data) {
        this.isLoading = false;
      }


      // Binding with the datasource
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }


  
  selectedgroups: any[] = [];
  navigateToGroupMembers(groupsId: any) {

    this.router.navigate(['/admin/reports/view-report'], {
      queryParams: { tab: 'group-members',groupsId }
    });
  }

 

  



}
